import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { RrmsDashboardComponent } from './rrms-dashboard/rrms-dashboard.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatIconModule, MatListModule, MatTooltipModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatMenuModule } from '@angular/material';
import { NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CheckBoxModule, ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { MultiSelectAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { DataTablesModule } from 'angular-datatables';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { SharedModule } from '../theme/shared/shared.module';
import { SmsPdpDashboardComponent } from './sms-pdp-dashboard/sms-pdp-dashboard.component';


@NgModule({
  declarations: [RrmsDashboardComponent, SmsPdpDashboardComponent],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    
    OwlDateTimeModule,
    OwlNativeDateTimeModule,


    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgbDatepickerModule,
    DataTablesModule,
    MatIconModule,
    MatListModule,
    MatTooltipModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    NgMultiSelectDropDownModule,
    MultiSelectAllModule,
    CheckBoxModule,
    ButtonModule,
    NumericTextBoxModule,
    Ng4LoadingSpinnerModule.forRoot(),
    MatMenuModule,
    SharedModule,
    NgbModule,
    DataTablesModule,
  ]
})
export class DashboardModule { }
